import { Icon, StoryGrid, Toolbar } from '../../components'
import { useNavigate, useParams } from 'react-router-dom'
import { PERMISSION } from '../../helpers'
import { useAffiliation, useSortStoryMutation } from '../../hooks'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'

export const AllStoriesView = ({ category, stories }) => {
  const { tenantUrlSlug, affiliationUrlSlug, categoryUrlSlug } = useParams()
  const { affiliation } = useAffiliation()
  const permissions = affiliation?.permissions
  const navigate = useNavigate()

  const { mutate: sortStory } = useSortStoryMutation()

  const handleDragEnd = ({ active, over }) => {
    const story = stories.find((story) => story.id === over.id)
    sortStory({
      categoryId: category.id,
      storyId: active.id,
      order: story.orderNumber
    })
  }

  return (
    <>
      <Toolbar title={category.name}>
        {permissions.includes(PERMISSION.EDIT) ? (
          <Button
            onClick={() =>
              navigate(
                `/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}/new`
              )
            }
            aria-label='Add Story'
            title='Create Story'
            variant='link'
          >
            <Icon icon={faPlusCircle} size='lg' />
            Add Story
          </Button>
        ) : null}
      </Toolbar>
      <StoryGrid
        stories={stories}
        pathname={`/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}`}
        draggable={permissions.includes(PERMISSION.EDIT)}
        onDragEnd={handleDragEnd}
      />
    </>
  )
}
